import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyMessage         from "../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import NotifyType            from "../../../domain/fundamentals/message/notify/NotifyType";
import PlanId                from "../../../domain/plan/PlanId";
import PlanRepository        from "../../../domain/plan/PlanRepository";
import PlanStatusType        from "../../../domain/plan/PlanStatusType";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import PlanDataSource        from "../../../infrastructure/datasource/plan/PlanDataSource";

class UpdatePlanStatus {
  constructor(
    private readonly dispatch,
    private readonly planRepository: PlanRepository = new PlanDataSource(),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }


  public async execute(planId: PlanId, statusType: PlanStatusType) {
    try {
      this.fetchStatusRepository.start();
      await this.planRepository.updateStatus(planId, statusType);
      this.notifyRepository.optionalMessage(NotifyType.SAVE_SUCCESS, new NotifyMessage("プランの予約受付を更新しました。"));
    } catch (e) {
      this.notifyRepository.optionalMessage(NotifyType.SAVE_FAILURE, new NotifyMessage("プランの予約受付が更新できませんでした。"));
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default UpdatePlanStatus;
